<template>
  <g clip-path="url(#clip0_8187_9235)">
    <path
      d="M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8.06609 3.58496C8.58993 1.59815 11.4101 1.59815 11.9339 3.58496L11.9748 3.73988C12.258 4.81401 13.3622 5.45156 14.434 5.15975L14.5886 5.11766C16.5712 4.57791 17.9813 7.02023 16.5225 8.4673L16.4088 8.58013C15.6202 9.36245 15.6202 10.6375 16.4088 11.4199L16.5225 11.5327C17.9813 12.9798 16.5712 15.4221 14.5886 14.8823L14.434 14.8403C13.3622 14.5484 12.258 15.186 11.9748 16.2601L11.9339 16.415C11.4101 18.4019 8.58993 18.4019 8.06609 16.415L8.02524 16.2601C7.74204 15.186 6.63778 14.5484 5.56595 14.8403L5.41137 14.8823C3.42882 15.4221 2.01874 12.9798 3.47746 11.5327L3.5912 11.4199C4.37982 10.6375 4.37982 9.36245 3.5912 8.58013L3.47746 8.4673C2.01874 7.02023 3.42882 4.57791 5.41137 5.11766L5.56595 5.15975C6.63778 5.45156 7.74204 4.81401 8.02524 3.73988L8.06609 3.58496Z"
      stroke="currentColor" stroke-width="1.5" />
  </g>
  <defs>
    <clipPath id="clip0_8187_9235">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</template>
